module.exports = __webpack_public_path__ + "static/media/1POLICY27.48977b26.jpg";